import requestManager from "@/utils/sanGao";

// 根据 orgId 查询机构信息
export function getSanGaoOrgById(params) {
    return requestManager.request({
        url: "/sanGao/getOrgById",
        method: "get",
        params,
    });
}

// 发送短信验证码
export function sendSanGaoCode(params) {
    return requestManager.request({
        url: "/sanGao/sendCode",
        method: "post",
        data: params,
    });
}

// 业务员注册：普通版短信验证，taikangMode=true 时由后端校验机构后免短信。
export function registerSanGaoSalesman(params) {
    return requestManager.request({
        url: "/sanGao/register",
        method: "post",
        data: params,
    });
}

// 业务员登录：普通版手机号+验证码；taikangMode=true 时手机号+业务员编码+orgId。
export function loginSanGaoSalesman(params) {
    return requestManager.request({
        url: "/sanGao/login",
        method: "post",
        data: params,
    });
}

// 校验 token，返回当前业务员信息
export function getSanGaoSalesmanInfo() {
    return requestManager.request({
        url: "/sanGao/salesmanInfo",
        method: "get",
    });
}

// 查询当前业务员关联的客户列表（仅查看，不含审核）
// auditStatus: 0-待审核 1-已通过 2-未通过 3-已支付 4-已退款
export function getSanGaoCustomerList(params) {
    return requestManager.request({
        url: "/sanGao/salesman/customerList",
        method: "get",
        params,
    });
}

// 全量保存当前业务员名下客户的自定义标签，tags: [] 表示清空
export function saveSanGaoCustomerTags(data) {
    return requestManager.request({
        url: "/sanGao/salesman/customerTags",
        method: "post",
        data,
    });
}

// 业务员为已审核客户支付体检费（支持批量）
// 与其他支付接口统一放在 OrgPayController 下，但走业务员 token 鉴权
// 入参: { customerIds: [..], wxCode }
// 返回: 微信支付参数（appId/timeStamp/nonceStr/packages/signType/paySign/payNo）
export function paySanGaoCustomer(params) {
    return requestManager.request({
        url: "/orgPay/getPayConfigByWechatSanGaoTiJian",
        method: "post",
        data: params,
    });
}

// 业务员对已支付客户退款（仅未预约或预约已取消的客户）
export function refundSanGaoCustomer(memberId) {
    return requestManager.request({
        url: `/sanGao/salesman/refund?memberId=${memberId}`,
        method: "post",
    });
}

// 本地体检详情（无记录时初始化）
export function getSanGaoExamDetail(memberId) {
    return requestManager.request({
        url: "/sanGao/exam/detail",
        method: "get",
        params: { memberId },
    });
}

// 按客户身份证性别和当前有效问卷病种匹配固定套餐
export function getSanGaoExamPackages(memberId) {
    return requestManager.request({
        url: "/sanGao/exam/packages",
        method: "get",
        params: { memberId },
    });
}

// 可约城市列表（美年 5.2，城市模式）
export function getSanGaoExamCities(packageId) {
    return requestManager.request({
        url: "/sanGao/exam/cities",
        method: "get",
        params: { packageId },
    });
}

// 机构明细（美年 5.3，含快捷可约日历）
export function getSanGaoExamUnits(params) {
    return requestManager.request({
        url: "/sanGao/exam/units",
        method: "get",
        params,
    });
}

// 门店排期（美年 5.4，month 模式）
export function getSanGaoExamSchedules(params) {
    return requestManager.request({
        url: "/sanGao/exam/schedules",
        method: "get",
        params,
    });
}

// 预约提交（美年 5.7）
export function bookSanGaoExam(data) {
    return requestManager.request({
        url: "/sanGao/exam/book",
        method: "post",
        data,
    });
}

// 预约改期（美年 5.8）
export function changeSanGaoExamDate(data) {
    return requestManager.request({
        url: "/sanGao/exam/changeDate",
        method: "post",
        data,
    });
}

// 预约取消（美年 5.9）
export function cancelSanGaoExam(memberId) {
    return requestManager.request({
        url: `/sanGao/exam/cancel?memberId=${memberId}`,
        method: "post",
    });
}
